module.exports = __webpack_public_path__ + "static/background-29513172d900cfc77d41a9d78e893061.jpg";